export const APP_RUNNING = 'APP/RUNNING'
export const APP_LOADING = 'APP/LOADING'
export const APP_ERROR = 'APP/ERROR'

export const FORM_PENDING = 'FORM/PENDING'
export const FORM_LOADING = 'FORM/LOADING'
export const FORM_ERROR = 'FORM/ERROR'
export const FORM_SUCCESS = 'FORM/SUCCESS'

export const ERROR_API_GENERAL = 'ERROR/API/GENERAL'
export const ERROR_API_RESPONSE = 'ERROR/API/RESPONSE'

export const STEP_TYPE = 'APP/STEP/TYPE'
export const STEP_LOCATION = 'APP/STEP/LOCATION'
export const STEP_DATETIME = 'APP/STEP/DATETIME'
export const STEP_REVIEW = 'APP/STEP/REVIEW'
export const STEP_CONFIRMATION = 'APP/STEP/CONFIRMATION'
export const STEP_ERROR = 'APP/STEP/ERROR'

export const MARKETING_STATE_FRESH = 'MARKETING/STATE/FRESH'
export const MARKETING_STATE_ACTIVE = 'MARKETING/STATE/ACTIVE'
export const MARKETING_STATE_CHECKED = 'MARKETING/STATE/CHECKED'
